/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import { Image,
Text,
TouchableOpacity,
TouchableHighlight,
View,
SafeAreaView,
Platform} from 'react-native';
import {Icon, Input} from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';
import styles from './styles';
import { AccountOverlay, Loader, KeyboardAwareScrollViewWithDismiss } from '../../components';
import {
Firestore,
Functions,
getAuth,
createUserWithEmailAndPassword} from '../../firebase/config';
import { WebView } from 'react-native-webview';

export default function RegistrationScreen({navigation}) {
    const [fullName, setFullName] = useState();
    const [email, setEmail] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [secureText, setSecureText] = useState(true);
    const [secureIcon, setSecureIcon] = useState('eye-off');
    const [accountNumber, setAccountNumber] = useState('');
    const [accountNumberErrorMessage, setAccountNumberErrorMessage] = useState('');
    const [billingZipCode, setBillingZipCode] = useState('');
    const [billingZipCodeErrorMessage, setBillingZipCodeErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [account, setAccount] = useState();
    const [disabled, setDisabled] = useState(false);
    const [termsLoading, setTermsLoading] = useState(true);
    const [registerDisabled, setRegisterDisabled] = useState(false);
    const [terms, setTerms] = useState();
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [overlayVisible, setOverlayVisible] = useState(true);
    const [accountVerified, setAccountVerified] = useState(false);
    const usersRef = Firestore.collection('users');
    const publicRef = Firestore.collection('Public');
    const auth = getAuth();

    useEffect(() => {
    publicRef
    .doc('Terms & Conditions')
    .get()
    .then((doc) => {
    const allData = [];
    const terms = doc.data();
    terms.id = doc.id
    allData.push(terms);
    setTerms(allData);
    setLoading(false);
    }).catch((err) => {
    console.error(`Error loading terms & conditions: ${err}`);
    setLoading(false);
    })
    }, []);

    const onFooterLinkPress = () => {
        navigation.navigate('Login');
    }

    const onRegisterPress = () => {
    setPasswordErrorMessage(null);
    setEmailErrorMessage(null);
    if (!(email)) {
    setEmailErrorMessage("Invalid Email Address");
    return;
    }
        if (password !== confirmPassword) {
            setPasswordErrorMessage("Passwords do not match");
            return;
        }
        else if (!acceptTerms) {
        alert("You must accept the Terms and Conditions in order to use this app!");
        return navigation.navigate('Login');
        }
        setLoading(true);
        setRegisterDisabled(true);
       //CREATE'S USER'S AUTH CREDENTIALS
       createUserWithEmailAndPassword(auth, email, password)
            .then((response) => {
                const uid = response.user.uid
                const now = new Date();
                const data = {
                    id: uid,
                    email,
                    fullName,
                    accountID: accountNumber.toUpperCase(),
                    dateCreated: {
                    date: now,
                    timestamp: now.getTime()
                    },
                    lastUpdateFetch: {
                    date: now,
                    timestamp: now.getTime()
                    },
                    unreadCounter: {
                    totalUnreadCount: 0
                    },
                    termsConditionsAccepted: acceptTerms
                };
                usersRef.doc(uid).set(data)
                .catch((err) => {
                console.error("Error creating user profile", err);
                setRegisterDisabled(false);
                setLoading(false);
                });
            })
            .catch((error) => {
            setRegisterDisabled(false);
            setLoading(false);
            console.error("Error creating user auth");
            switch (error.code) {
            case "auth/email-already-in-use":
            setEmailErrorMessage("Email address is already in use");
            break;
            case "auth/invalid-email":
            setEmailErrorMessage("Invalid Email Address");
            break;
            default: setEmailErrorMessage(error.code + " | If issue persists, please contact support");
            }
        });
    }


function verifyAccount() {
setAccountNumberErrorMessage(null);
setBillingZipCodeErrorMessage(null);
if (!accountNumber) {
setAccountNumberErrorMessage("Enter Account Number");
return;
}
if (!billingZipCode) {
setBillingZipCodeErrorMessage("Enter Billing Zip Code");
return;
}
return new Promise(async function (resolve, reject) {
setLoading(true);
setDisabled(true);
await Functions.httpsCallable('accountLookup')({
accountID : accountNumber.toUpperCase(),
zipcode : billingZipCode,
})
.then(function (response) {
setLoading(false);
if (response.data.code === 200) {
setAccount(response.data.message);
setOverlayVisible(true);
resolve();
}
else {
switch (response.data.code) {
case 404:
setAccountNumberErrorMessage(response.data.message);
setBillingZipCodeErrorMessage(response.data.message);
break;
case 500:
setAccountNumberErrorMessage(response.data.message);
setBillingZipCodeErrorMessage(response.data.message);
}
setDisabled(false);
setLoading(false);
}
}).catch((error) => {
console.error("Error verifying account");
switch (error.code) {
case 404:
setAccountNumberErrorMessage(response.data.message);
setBillingZipCodeErrorMessage(response.data.message);
break;
case 500:
setAccountNumberErrorMessage(response.data.message);
setBillingZipCodeErrorMessage(response.data.message);
}
setDisabled(false);
setLoading(false);
reject();
});
})
}

//Continue btn pressed on account overlay component
const onAccountOverlayContinue = () => {
setOverlayVisible(!overlayVisible);
setAccountVerified(true);
}

//Back btn pressed on account overlay component
const onAccountOverlayBack = () => {
setOverlayVisible(!overlayVisible);
setDisabled(false);
}

  if (loading) {
    return (
     <Loader />
    )
  }

const loadingProp = () => {
return (
<Loader />
)
}


if (!acceptTerms && terms) {
return (
<View style={styles.termsContainer}>
{Platform.OS === 'web'?
<View style={{backgroundColor: "white", flex: 1}}>
<iframe src={terms[0].url} height={"100%"} width={"100%"} onLoad={() => {setTermsLoading(false);}}
/>
</View>
:
<WebView
source={{uri: terms[0].url}}
onLoadStart={() => {setTermsLoading(true)}}
onLoad={() => {setTermsLoading(false)}}
thirdPartyCookiesEnabled={false}
startInLoadingState={true}
renderLoading={loadingProp}
/>
}
<View style={styles.termsButtonContainer}>

{termsLoading? (
<>
</>
) : (
<>
<TouchableHighlight
onPress={() => setAcceptTerms(true)}
>
<View style={styles.textIcon}>
<Icon style={styles.iconPadding} name="check" size={30} color="green" />
<Text style={styles.termsButtonTextAccept}>Accept Terms & Conditions</Text>
</View>
</TouchableHighlight>
<TouchableHighlight
onPress={() => alert("You must accept the terms & conditions in order to use this app.")}
>
<View style={styles.textIcon}>
<Icon style={styles.iconPadding} name="block" size={30} color="red" />
<Text style={styles.termsButtonTextDecline}>Decline Terms & Conditions</Text>
</View>
</TouchableHighlight>
</>
)}
</View>
</View>
)
}

const toggleSecureText = () => {
setSecureText(
secureText !== true
);
setSecureIcon(
secureIcon === "eye-off"
? "eye"
: "eye-off"
)

}


if (accountVerified && acceptTerms) {
    return (
    <View style={{flex: 1}}>
                   <LinearGradient
                    colors={['black', '#590000']}
                    locations={[.1,1]}
                    style={{flex: 1}}
                    >
        <SafeAreaView style={styles.container}>
        <KeyboardAwareScrollViewWithDismiss>
                       <View style={styles.container}>
                               <Image
                               style={styles.logo}
                               source={require('../../../assets/empireLogoTransparent.png')}
                               />
                               <Text style={styles.appMessage}>User Profile</Text>

                <Input
                 containerStyle={styles.actionInput}
                 inputStyle={styles.inputStyle}
                 inputContainerStyle={styles.inputContainerStyle}
                 leftIcon={{name: 'person', color: 'black'}}
                 placeholder='Full Name'
                 onChangeText={(text) => {setFullName(text)}}
                 value={fullName}
                 autoCapitalize="none"
                 autoCompleteType={"name"}
                 textContentType={"name"}
                 />
                <Input
                 containerStyle={styles.actionInput}
                 inputStyle={styles.inputStyle}
                 inputContainerStyle={styles.inputContainerStyle}
                 errorMessage={emailErrorMessage}
                 leftIcon={{name: 'mail', color: 'black'}}
                 placeholder='Email Address'
                 onChangeText={(text) => {setEmail(text)}}
                 value={email}
                 autoCapitalize="none"
                 textContentType={'emailAddress'}
                 autoComplete={'email'}
                 />

                <Input
                 secureTextEntry={secureText}
                 containerStyle={styles.actionInput}
                 inputStyle={styles.inputStyle}
                 inputContainerStyle={styles.inputContainerStyle}
                 leftIcon={{name: 'lock', color: 'black'}}
                 rightIcon={{type: 'feather', name: secureIcon, color: 'black', onPress: () => {toggleSecureText();}}}
                 placeholder='Password'
                 errorMessage={passwordErrorMessage}
                 onChangeText={(text) => setPassword(text)}
                 value={password}
                 autoCapitalize="none"
                 textContentType={'newPassword'}
                 autoComplete={'password'}
                 />
                <Input
                 secureTextEntry={secureText}
                 containerStyle={styles.actionInput}
                 inputStyle={styles.inputStyle}
                 inputContainerStyle={styles.inputContainerStyle}
                 leftIcon={{name: 'lock', color: 'black'}}
                 rightIcon={{type: 'feather', name: secureIcon, color: 'black', onPress: () => {toggleSecureText();}}}
                 placeholder='Confirm Password'
                 errorMessage={passwordErrorMessage}
                 onChangeText={(text) => {setConfirmPassword(text)}}
                 value={confirmPassword}
                 autoCapitalize="none"
                 textContentType={'password'}
                 autoComplete={'password-new'}
                 />
                <TouchableOpacity
                    style={styles.button}
                    disabled={registerDisabled}
                    onPress={() => onRegisterPress()}>
                    <Text style={styles.buttonTitle}>Create Account</Text>
                </TouchableOpacity>
                <View style={styles.footerView}>
                    <Text style={styles.footerText}>Returning User? <Text onPress={onFooterLinkPress} style={styles.footerLink}>Log in</Text></Text>
                </View>
                </View>
        </KeyboardAwareScrollViewWithDismiss>
        </SafeAreaView>
        </LinearGradient>
</View>
    )
    }
    else {
    return (
     <SafeAreaView style={styles.container}>
     {acceptTerms &&
                <KeyboardAwareScrollViewWithDismiss>
                <>
                    <View style={styles.container}>
                    <Image
                     style={styles.logo}
                     source={require('../../../assets/empireLogoTransparent.png')}
                    />
                   <View style={styles.registrationContainer}>
                   <Input
                    inputStyle={styles.inputStyle}
                    inputContainerStyle={styles.inputContainerStyle}
                    containerStyle={styles.actionInput}
                    placeholder="Account Number"
                    errorMessage={accountNumberErrorMessage}
                    maxLength={7}
                    leftIcon={{name: 'business', color: 'black'}}
                    onChangeText={(text) => setAccountNumber(text)}
                    value={accountNumber}
                    autoCapitalize="none"
                    autoComplete="off"
                    autoCorrect={false}
                   />
                  <Input
                   inputStyle={styles.inputStyle}
                   inputContainerStyle={styles.inputContainerStyle}
                   containerStyle={styles.actionInput}
                   placeholder="Billing Zip Code"
                   errorMessage={billingZipCodeErrorMessage}
                   leftIcon={{name:"contact-mail", color: 'black'}}
                   onChangeText={(text) => {setBillingZipCode(text)}}
                   value={billingZipCode}
                   autoCapitalize="none"
                   maxLength={5}
                   keyboardType="numeric"
                 />
                </View>
                <View style={styles.container}>
                <View style={styles.actionButtonsContainer}>
                <TouchableOpacity
                 style={styles.button}
                 disabled={disabled}
                 onPress={() => {verifyAccount()}}>
                <Text style={styles.buttonTitle}>Verify Account</Text>
                </TouchableOpacity>
                <View style={styles.footerView}>
                <Text style={styles.footerText}>Returning User? <Text onPress={onFooterLinkPress} style={styles.footerLink}>Log in</Text></Text>
                </View>
                </View>
                </View>
                </View>
                {account && (
                <AccountOverlay
                 name={account.address.name}
                 addressline1={account.address.addressline1}
                 city={account.address.city}
                 state={account.address.state}
                 zipcode={account.address.zipcode}
                 overlayVisible={overlayVisible}
                 continueBtnAction={() => {onAccountOverlayContinue();}}
                 backBtnAction={() => {onAccountOverlayBack();}}
                />
                 )}
                 </>
                </KeyboardAwareScrollViewWithDismiss>
                 }
                </SafeAreaView>
                  )
                  }}